export default __webpack_public_path__ + "static/media/bg-masthead-2-640w.e539e9e1.webp";